import Layout from '@/components/feature/Layout';
import { companyInfo } from '@/mocks/company';
import { products } from '@/mocks/products';
import { Link } from 'react-router-dom';

const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

const schema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: companyInfo.name,
  alternateName: companyInfo.tradingName,
  url: 'https://maquinadesoldageomembrana.com.br',
  email: companyInfo.email,
  telephone: companyInfo.phone,
  foundingDate: '2016',
  address: {
    '@type': 'PostalAddress',
    streetAddress: companyInfo.address,
    addressLocality: companyInfo.city,
    addressRegion: companyInfo.state,
    addressCountry: companyInfo.country,
  },
  sameAs: [companyInfo.facebook, companyInfo.instagram],
};

const stats = [
  { icon: 'ri-calendar-check-line', value: `+${companyInfo.years}`, label: 'Anos de Experiência' },
  { icon: 'ri-map-pin-2-line', value: 'Brasil', label: 'Empresa 100% Brasileira' },
  { icon: 'ri-tools-fill', value: `${companyInfo.models}`, label: 'Modelos em Catálogo' },
  { icon: 'ri-customer-service-2-line', value: '100%', label: 'Suporte Técnico' },
];

const diferenciais = [
  { icon: 'ri-tools-line', title: 'Serviço Técnico Oficial', desc: 'Reparos e manutenções com peças originais de fábrica, garantindo a vida útil do seu equipamento.' },
  { icon: 'ri-global-line', title: 'Atendimento Nacional', desc: 'Atendemos todo o Brasil com logística especializada e entrega rápida.' },
  { icon: 'ri-shield-check-line', title: 'Garantia de Qualidade', desc: 'Equipamentos importados com certificação e procedência garantida de fabricantes reconhecidos.' },
  { icon: 'ri-customer-service-2-line', title: 'Suporte Dedicado', desc: 'Nossa equipe responde via WhatsApp com agilidade, antes e depois da venda.' },
];

const categorias = [
  { id: 'cunha-quente', nome: 'Cunha Quente', icone: 'ri-fire-line', desc: 'Máquinas automáticas para soldagem contínua de geomembranas em grandes áreas.' },
  { id: 'extrusora', nome: 'Extrusoras', icone: 'ri-tools-fill', desc: 'Equipamentos de soldagem por extrusão para reparos, cantos e detalhes.' },
  { id: 'acessorio', nome: 'Acessórios', icone: 'ri-settings-3-line', desc: 'Sopradores, rolos e itens complementares para acabamento profissional.' },
];

export default function SobrePage() {
  return (
    <Layout>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="w-full px-4 md:px-6 lg:px-10 pt-28 md:pt-32 pb-16 md:pb-24">
        <nav className="text-xs text-foreground-400 mb-6 flex items-center gap-2 flex-wrap">
          <Link to="/" className="hover:text-primary-600 cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line text-foreground-300" />
          <span className="text-foreground-600">Sobre a Empresa</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16">
          <div>
            <span className="text-primary-500 text-xs uppercase tracking-widest mb-3 block">Sobre Nós</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight mb-5">
              {companyInfo.name}
            </h1>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-4">
              A <strong className="text-foreground-950 font-bold">{companyInfo.name}</strong> é uma empresa especializada na importação e distribuição de <strong className="text-foreground-950 font-bold">máquinas de solda de geomembrana</strong>, com mais de <strong className="text-foreground-950 font-bold">{companyInfo.years} anos de experiência</strong> no mercado.
            </p>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              Sediada em <strong className="text-foreground-950 font-bold">{companyInfo.city} ({companyInfo.state})</strong>, fornecemos equipamentos de alta performance para impermeabilização em todo o Brasil.
            </p>
          </div>
          <div className="relative">
            <div className="grid grid-cols-2 gap-3">
              <div className="w-full h-52 md:h-64 rounded-2xl overflow-hidden">
                <img
                  alt="Estoque de máquinas de solda geomembrana"
                  className="w-full h-full object-cover object-top"
                  src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=487,fit=crop/A0xVvobDbRIBrVE7/muchas-rojas-con-cajas-A8543EvBNjfW0ORg.jpg"
                />
              </div>
              <div className="w-full h-52 md:h-64 rounded-2xl overflow-hidden mt-6 md:mt-8">
                <img
                  alt="Soldadoras para geomembrana disponíveis"
                  className="w-full h-full object-cover object-top"
                  src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=486,fit=crop/A0xVvobDbRIBrVE7/muchas-soldadoras-rojas-mxB7kMa8jKhoPalp.jpg"
                />
              </div>
            </div>
            <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-primary-500 text-white text-sm px-5 py-2 rounded-full whitespace-nowrap font-bold">
              +{companyInfo.years} anos de experiência
            </div>
          </div>
        </div>

        <div className="bg-foreground-950 rounded-2xl p-8 md:p-12 mb-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0 md:divide-x md:divide-foreground-800">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center text-center md:px-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
                  <i className={`${s.icon} text-primary-400 text-lg`} />
                </div>
                <span className="text-white font-bold text-2xl uppercase leading-none">{s.value}</span>
                <span className="text-foreground-500 text-xs mt-1 uppercase tracking-wide text-center">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-3 block">Nossa História</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 uppercase leading-tight mb-6">
            Quem Somos e o Que Fazemos
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white border border-background-200/70 rounded-2xl p-6 md:p-8">
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                Fundada com a missão de profissionalizar o mercado de impermeabilização no Brasil, a {companyInfo.name} tornou-se referência no fornecimento de equipamentos para soldagem de geomembranas.
              </p>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Importamos máquinas de fabricantes reconhecidos mundialmente — como <strong className="text-foreground-950">Weldy</strong> e <strong className="text-foreground-950">Metabo</strong> — e distribuímos com estoque local, suporte técnico especializado e peças originais de fábrica.
              </p>
            </div>
            <div className="bg-white border border-background-200/70 rounded-2xl p-6 md:p-8">
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                Nossos equipamentos atendem projetos de <strong className="text-foreground-950">aterros sanitários, mineração, reservatórios, barragens, canais de irrigação, piscicultura e saneamento</strong>.
              </p>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Mais do que vender máquinas, ajudamos engenheiros e contratistas a escolher o equipamento ideal para cada projeto — com indicação técnica precisa e acompanhamento pós-venda.
              </p>
            </div>
          </div>
        </div>

        <div className="mb-16">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-3 block">Diferenciais</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 uppercase leading-tight mb-8">
            Por Que Escolher a {companyInfo.name}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {diferenciais.map((d) => (
              <div key={d.title} className="bg-white border border-background-200/70 rounded-2xl p-6 flex flex-col">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                  <i className={`${d.icon} text-primary-600 text-xl`} />
                </div>
                <h3 className="text-foreground-950 font-bold text-sm uppercase mb-2">{d.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{d.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-3 block">Catálogo</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 uppercase leading-tight mb-8">
            O Que Distribuímos
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {categorias.map((c) => {
              const count = products.filter((p) => p.category.toLowerCase() === (c.id === 'cunha-quente' ? 'Cunha Quente' : c.id === 'extrusora' ? 'Extrusora' : 'Acessório')).length;
              return (
                <Link
                  key={c.id}
                  to="/modelos-de-maquinas"
                  className="group bg-white border border-background-200/70 rounded-2xl p-6 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                    <i className={`${c.icone} text-accent-700 text-xl`} />
                  </div>
                  <h3 className="text-foreground-950 font-bold text-lg uppercase mb-1">{c.nome}</h3>
                  <span className="text-primary-600 text-xs font-bold uppercase tracking-wide mb-2">{count} modelo{count !== 1 ? 's' : ''}</span>
                  <p className="text-foreground-500 text-xs leading-relaxed mb-4">{c.desc}</p>
                  <span className="inline-flex items-center gap-1 text-primary-600 text-xs font-bold uppercase tracking-wide group-hover:gap-2 transition-all">
                    Ver modelos <i className="ri-arrow-right-line" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:gap-12 mb-12">
          <div>
            <span className="text-primary-500 text-xs uppercase tracking-widest mb-3 block">Localização</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 uppercase leading-tight mb-6">
              Onde Estamos
            </h2>
            <div className="bg-white border border-background-200/70 rounded-2xl p-6 md:p-8 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-primary-600" />
                </div>
                <div>
                  <p className="text-foreground-900 font-bold text-sm">Endereço</p>
                  <p className="text-foreground-500 text-sm leading-relaxed">{companyInfo.address}, {companyInfo.city} — {companyInfo.state}, {companyInfo.country}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                  <i className="ri-phone-line text-primary-600" />
                </div>
                <div>
                  <p className="text-foreground-900 font-bold text-sm">Telefone</p>
                  <p className="text-foreground-500 text-sm">{companyInfo.phone}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                  <i className="ri-mail-line text-primary-600" />
                </div>
                <div>
                  <p className="text-foreground-900 font-bold text-sm">E-mail</p>
                  <p className="text-foreground-500 text-sm">{companyInfo.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 pt-2">
                <a href={companyInfo.facebook} target="_blank" rel="nofollow noreferrer" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 hover:bg-primary-500 hover:text-white text-foreground-600 transition-colors cursor-pointer" aria-label="Facebook">
                  <i className="ri-facebook-line text-lg" />
                </a>
                <a href={companyInfo.instagram} target="_blank" rel="nofollow noreferrer" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 hover:bg-primary-500 hover:text-white text-foreground-600 transition-colors cursor-pointer" aria-label="Instagram">
                  <i className="ri-instagram-line text-lg" />
                </a>
                <a href={whatsappUrl} target="_blank" rel="nofollow noreferrer" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 hover:bg-primary-500 hover:text-white text-foreground-600 transition-colors cursor-pointer" aria-label="WhatsApp">
                  <i className="ri-whatsapp-line text-lg" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-primary-50 rounded-2xl border border-primary-200/70 p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 uppercase mb-1">Quer falar com nossa equipe?</h3>
            <p className="text-foreground-500 text-sm">Estamos prontos para indicar o equipamento ideal para o seu projeto.</p>
          </div>
          <a href={whatsappUrl} target="_blank" rel="nofollow noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide flex-shrink-0">
            <i className="ri-whatsapp-line" /> Falar no WhatsApp
          </a>
        </div>
      </div>
    </Layout>
  );
}